import React from 'react';
import { BrowserRouter as Router, Route, Link, NavLink, Switch } from 'react-router-dom'
// import firebase from 'firebase';
import _ from 'lodash';
import Display from '../helpers/display';
import Generate from '../helpers/generate';
import ProfilePreview from './profile.preview';

class Profiles extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			loaded: false,
			view: 'wallet',
			walletRankings: null,
			educationRankings: null,
			leaders:null,
			searchText: '',
			searchResults: null
		}
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleUpdates = this.handleUpdates.bind(this);
		this.handleGenerateProfileClick = this.handleGenerateProfileClick.bind(this);
	}

	handleGenerateProfileClick () {
		// console.log('handleGenerateProfileClick', this.props.game.id);
		Generate.profile(this.props.game.id, {})
		.then(response => {
			// console.log('profile created', response);
			this.setState({ complete: true });
		})
		.catch(error => {
			// console.warn('profile creation error', error)
			this.setState({ loading: false });
		})
	}

	handleInputChange(event) {
		let value = event.target.value;
		this.setState({searchText: value});
		if(!value) {
			this.setState({searchResults: null})
			return
		}
		// let self = this;
		let results = _.filter(this.props.profiles, (profile) => {
			return profile.name.toLowerCase().includes(value.toLowerCase());
		});
		this.setState({searchResults:results})
	}

	handleUpdates() {
		this.setState({walletRankings: Display.orderProfilesByWallet(this.props.profiles)});
		this.setState({educationRankings: Display.orderProfilesByEducation(this.props.profiles)});
		this.setState({leaders: Display.getLeaderProfiles(this.props.profiles)});
		this.setState({loaded: true});
	}

	componentDidMount() {
		this.handleUpdates();
	}

	componentDidUpdate(newProps) {

		console.log('component updated',this.props);

		if(newProps.profiles !== this.props.profiles) {
			this.handleUpdates();
		}
	}

	render() {

		return <section className="profiles-page ridged -bottom">

		<div className="content">

			<div className="profiles-header">
				<h3>{Display.totalParticipants(this.props.profiles)} People</h3>

				<nav className="tabs">
					<NavLink className="button -tab" to={`/game/${this.props.game.id}/wallet`}>Wallet</NavLink>
					<NavLink className="button -tab" to={`/game/${this.props.game.id}/education`}>Education</NavLink>
					<NavLink className="button -tab" to={`/game/${this.props.game.id}/leaders`}>Leaders</NavLink>

					<input className="-tab" name="search" type="text" placeholder="Search" value={this.state.searchText} onChange={this.handleInputChange}/>
				</nav>
			</div>

			<div className="profile-list">
				{this.state.loaded === false && <div className="loading">
					<div className="loader">
						<div>
							<span></span>
							<span></span>
						</div>
					</div>
				</div>}
				{/* Search Results */}
				{this.state.searchText && <ul className="profiles -search -plain">
				<h3>Searching for "{this.state.searchText}"</h3>
				{this.state.searchResults.map((profile) => <li key={profile.id}><ProfilePreview profile={profile} profileId={profile.id} gameId={this.props.game.id} show="wallet"/></li>)}
				{this.state.searchResults && this.state.searchResults.length === 0 && <li className="profile -empty">No one matched that search</li>}
				</ul>}

				{/* Wallet Rankings */}
				{!this.state.searchText && this.props.rankBy === 'wallet' && this.state.walletRankings && <ul className="profiles -wallet -plain">
				<h3>Cash Rankings</h3>
				{Object.keys(this.state.walletRankings).map(id =>
					<li key={this.state.walletRankings[id].id}><ProfilePreview profile={this.state.walletRankings[id]} profileId={this.state.walletRankings[id].id} gameId={this.props.game.id} rank={id - -1}  show="wallet"/></li>
				)}
				{this.state.walletRankings && this.state.walletRankings.length === 0 && <li className="profile -empty">No participants</li>}
				</ul>}

				{/* Education Rankings */}
				{!this.state.searchText && this.props.rankBy === 'education' && this.state.educationRankings && <ul className="profiles -education -plain">
				<h3>Education Rankings</h3>
				{Object.keys(this.state.educationRankings).map(id =>
					<li key={this.state.educationRankings[id].id}><ProfilePreview profile={this.state.educationRankings[id]} profileId={this.state.educationRankings[id].id} gameId={this.props.game.id} rank={id - -1}  show="education"/></li>
				)}
				{this.state.walletRankings && this.state.walletRankings.length === 0 && <li className="profile -empty">No participants</li>}
				</ul>}

				{/* Leader Listing */}
				{!this.state.searchText && this.props.rankBy === 'leaders' && this.state.educationRankings && <ul className="profiles -education -plain">
				<h3>Leaders</h3>
				{Object.keys(this.state.leaders).map(id =>
					<li key={this.state.leaders[id].id}><ProfilePreview profile={this.state.leaders[id]} profileId={this.state.leaders[id].id} gameId={this.props.game.id} rank={id - -1}  show="permission"/></li>
				)}
				</ul>}
			</div>

		</div>
		</section>


	}
}

export default Profiles



// WEBPACK FOOTER //
// ./src/components/game/profiles.js